import { render, staticRenderFns } from "./SignOut.vue?vue&type=template&id=508f4e20&scoped=true"
import script from "./SignOut.vue?vue&type=script&lang=js"
export * from "./SignOut.vue?vue&type=script&lang=js"
import style0 from "./SignOut.vue?vue&type=style&index=0&id=508f4e20&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "508f4e20",
  null
  
)

export default component.exports